// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__6S0tv","header":"ReportDetails_header__Up7Ol","title":"ReportDetails_title__fOg0O","left":"ReportDetails_left__EBHJI"};